module.exports = {
    baseUrl: 'http://localhost:1337',
    merchandisesKey: 'merchandisesKey',
    portsKey: 'portsKey',
    customersKey: 'customersKey',
    tokensKey: 'tokens',
}
